export const SUBSCRIPTION_PROFILE_LABELS = {
  accountRole: "Hub Admin",
  planUnavailable: "N/A",
  trialBadge: "Trial",
  trialBadgeDays: (days) => `${days}-Day Trial`,
  expiresInDays: (days) => `Expires in ${days} day${days === 1 ? "" : "s"}`,
  daysRemaining: (days) => `${days} day${days === 1 ? "" : "s"} remaining`,
  progressDays: (remaining, total) => `${remaining} / ${total} days`,
  manageSubscription: "Manage Subscription",
  renewSubscription: "Renew Subscription",
  renewNow: "Renew Now",
  helpSupport: "Help & Support",
  signOut: "Sign Out",
  alertRenewSoonTitle: "Subscription expiring soon",
  alertRenewSoonBody: "Renew now to avoid service interruption.",
  alertRenewSoonBodyActive: "Renew now to keep your store active.",
  alertTomorrowTitle: "Subscription expires tomorrow",
  alertTomorrowBody: "Renew now to keep your store online.",
  alertExpiredTitle: "Subscription expired",
  alertExpiredBody: "Renew to continue managing your business.",
};
